const menuConfigs = {
  openStorage: false,
  openMarket: false,
  openSubs: false,
};

export default menuConfigs;
